import styled from 'styled-components';
import LandingCssStyles from './LandingcssStyles';
import CssNav from './cssNav';
import theme from '../../theme';
import endPoints from '../../config/endPoints';

const StyledLanding = styled.div`
${LandingCssStyles}
${CssNav}
/* margin-bottom:-113px; */
background:${(props) => props.theme.whiteColor};


h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-family: 'Lato', sans-serif !important;
  color: ${theme.LandingBlack} !important;
}
h1{
  font-size: 40px;
  font-weight: 400;
}
h2 {
  font-size: 30px;
  font-weight: 500;
}
h3 {
  font-size: 24px;
  font-weight: 500;
}

h4 {
  font-size: 18px;
  font-weight: 400;
}

h5 {
	color: #626262;
}

a {
	text-decoration: none;
}

ul {}

li {
	color: #626262;
	line-height: 30px;
}

p {
	color: #505050;
  line-height: 26px;
  font-weight: 400;
  font-size: 16px;
  font-family: 'Muli', sans-serif !important;
}

span {}

.img-fluid {
	height: 60px;
	margin-bottom: 30px;
	width: 60px;
}

.container-full {
	padding-left: 0;
	padding-right: 0;
}

.btn {
	border: 1px solid ${(props) => props.theme.whiteColor};
	border-radius: 50px;
	color: ${(props) => props.theme.whiteColor};
	padding: 15px 40px;
	-moz-transition: all 0.5s ease-in-out 0s;
	-ms-transition: all 0.5s ease-in-out 0s;
	-o-transition: all 0.5s ease-in-out 0s;
	-webkit-transition: all 0.5s ease-in-out 0s;
	transition: all 0.5s ease-in-out 0s;
}

.btn-default:hover {
	color:${(props) => props.theme.whiteColor};
	background-color: #e6e6e6;
	border-color: #adadad;
}


/* Back to top button */

.back-to-top {
	position: fixed;
	display: none;
	background: ${(props) => props.theme.primaryColor};
	line-height: 1;
	color:${(props) => props.theme.whiteColor};
	padding: 7px 12px 13px 12px;
	border-radius: 2px;
	right: 15px;
	bottom: 15px;
	transition: background 0.5s;
}

@media (max-width: 768px) {
	.back-to-top {
		bottom: 15px;
	}
}

.back-to-top:focus {
	background: ${(props) => props.theme.primaryColor};
	color:${(props) => props.theme.whiteColor};
	outline: none;
}

.back-to-top:hover {
	background: #55b03f;
	color:${(props) => props.theme.whiteColor};
}

.line-height-30{
	line-height: 30px;
}
.home-strong{
	font-size: 14px;
    font-weight: normal;
    color: ${(props) => props.theme.mediumGrey};
}

/*--------------------------------------------------------------
# Top Menu
--------------------------------------------------------------*/

.top-menu {
	background: rgba(255, 255, 255, 0.68);
	position: fixed;
	width: 100%;
	z-index: 9;
	height: 40px;
	padding-top: 5px;
	top:30px;
}

.top-menu.hide {
	display: none;
}

.top-menu ul {
	margin: 0px;
	padding: 0px;
	text-align: right;
}

.top-menu ul li {
	display: inline-block;
	margin-left: 20px;
}

.top-menu ul li a {
	color:${(props) => props.theme.blackColor};
  padding: 5px 10px;
  font-size: 15px;
}

.top-menu ul li a.active {
	border-bottom: ${(props) => props.theme.primaryColor} solid 2px;
}

.top-menu ul li a:hover {
	text-decoration: none;
	border-bottom: ${(props) => props.theme.primaryColor} solid 2px;
}


/*--------------------------------------------------------------
# Banner
--------------------------------------------------------------*/

.banners {
  position: relative;
  background-position: center center;
  background-size: cover;
  height: 50em;
}

.banners.center{
	height: 40em;
}

.banners.center .caption {
	/* position: absolute; */
	/* top: 35%;
	width: 100%;
	left: auto;
	padding: 0px 10%;
	text-align: center; */
	text-align: center;
}

.banners.center .carousel-item {
	height: 40em;
}

.banners .caption {
	/* position: absolute; */
	margin-top: 20%;
	/* left: 12%;
	width: 40%; */
}
.banners.homeBanner .caption {
	position: absolute;
	margin-top: 18%;
	left: 12%;
	width: 40%;
}

.banners .caption h3 {
	color: #434343;
	line-height: 50px;
}

.banners .caption p {
	line-height: 1.6;
}

.banners .caption a.button {
	background: ${(props) => props.theme.primaryColor};
	border-radius: 25px;
	padding: 10px 20px;
	color: ${(props) => props.theme.whiteColor};
	text-decoration: none;
	transition: 0.3s;
	margin-top: 26px;
	display: inline-block;
}

.banners .caption a.button:hover {
	background: #f95a61;
	color: ${(props) => props.theme.whiteColor};
}
.banners .caption button.button {
	background: ${(props) => props.theme.primaryColor};
	border-radius: 25px;
	padding: 15px 20px;
	font-weight: normal;
	color: ${(props) => props.theme.whiteColor};
	text-decoration: none;
	transition: 0.3s;
	margin-top: 26px;
	display: inline-block;
}

.banners .caption button.button:hover {
	background: #f95a61;
	color: ${(props) => props.theme.whiteColor};
}


/*--------------------------------------------------------------
# banners
--------------------------------------------------------------*/

.static-banners {
	background: #eadedf;
	padding-top: 210px;
}

.banners-img {
	background: #eadedf;
	padding: 250px 0 100px 0px;
}

.banners-img img {
	margin-bottom: -20%;
}

.banners-img h1 {
	line-height: 48px;
}

.static-banners h3 {
	line-height: 45px;
	margin-bottom: 20px;
}

.scroll-header {
	background: ${(props) => props.theme.whiteColor};
	box-shadow: 0 3px 7px rgba(0, 0, 0, 0.1);
}

.scroll-header#header {
	top: 30px;
}

/*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/

.padd-section {
	padding-bottom: 80px;
	padding-top: 80px;
}

@media (max-width: 992px) {
	.padd-section {
		padding-top: 40px;
		padding-bottom: 40px;
	}
}

.section-title {
	margin-bottom: 80px;
}

@media (max-width: 992px) {
	.section-title {
		margin-bottom: 40px;
	}
}

.section-title h2 {
	margin-bottom: 20px;
}

.section-title .separator {
	margin: 0;
}

.separator {
	color: #626262;
	margin-bottom: 30px;
}


/* Get Started Section
--------------------------------*/

#get-started {
	display: inline-block;
	height: 100%;
	width: 100%;
	background: url(${endPoints.TRUSTED_BG});
	margin-top: -150px;
	padding-top: 200px;
	padding-bottom: 125px;
	position:relative;
}

#get-started .explore-btn{
	position: absolute;
    bottom: 15px;
    left: 30%;
	cursor: pointer;
	@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      position: static;
    };
}
#get-started .section-title h2 {
	color: ${theme.whiteColor} !important;
}

#get-started .section-title p {
	color: ${(props) => props.theme.whiteColor};
}

#get-started .explore {
	margin: 0px;
	padding: 0px;
	list-style: none;
}

#get-started .explore li {
	width: 15%;
	margin-right: 2%;
	float: left;
}

#get-started .explore li:last-child {
	/* width: 12%; */
	margin-right: 0;
}

#get-started .feature-block {
	background: ${(props) => props.theme.whiteColor} none repeat scroll 0 0;
	padding: 20px 10px 10px 10px;
	transition: all 0.5s ease-in-out 0s;
	border-radius: 20px;
	box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
	position: relative;
	z-index: 0;
	height: 245px;
}

#get-started .feature-block:after {
	content: "";
	box-shadow: 10px 10px 0px 0px rgba(255, 255, 255, 0.20);
	width: 100%;
	height: 245px;
	background: ${(props) => props.theme.transparentColor};
	position: absolute;
	z-index: -1;
	top: 0;
	left: 0;
	border-radius: 20px;
}

@media (max-width: 991px) {
	#get-started .feature-block {
		margin-bottom: 30px;
	}
}

#get-started .feature-block:hover {
	box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
	transition: all 0.5s ease-in-out 0s;
	background: ${(props) => props.theme.lightWhite};

}

#get-started .feature-block h4 {
	margin-bottom: 15px;
	
	line-height: 22px;
}

#get-started .section-title .brand-logos {
	max-width: 100%;
	height: 60px;
	margin-top: 30px;
	margin-bottom: 0px;
}

#get-started .feature-block p {
	margin-bottom: 20px;
	height: 95px;
}

#get-started .feature-block a {
	color: ${(props) => props.theme.primaryColor};
	text-decoration: none;
	transition: 0.3s;
}
#get-started .feature-block a:hover{
	color: #960c11
}


/* Features Section
--------------------------------*/

#features {
	display: inline-block;
	height: 100%;
	width: 100%;
	background: ${(props) => props.theme.lightWhite};
	padding-bottom: 0px;
}

#features .img-height {
	height: 88px;
}

#features .section-title h2 {
	
}

#features .section-title .separator {
	
}

#features .feature-block {
	background: ${(props) => props.theme.transparentColor};
	padding: 30px 20px;
	transition: all 0.5s ease-in-out 0s;
}

#features .feature-block:hover {
	/* box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease-in-out 0s; */
}

.one {
	margin-left: -100px;
	width: 100%;
}

#features .feature-block h4 {
	margin-bottom: 10px;
}

#features .feature-block p {
	margin-bottom: 0;
	
}

.features-bottom {
	width: 100%;
}


/* How it works Section
--------------------------------*/

#how-it-works {
	display: inline-block;
	height: 100%;
	width: 100%;
	background:${(props) => props.theme.lightWhite};
	padding-bottom: 0px;
}

#how-it-works .section-title {
	margin-bottom: 0px;
}

#how-it-works .section-title h2 {
	
	margin-bottom: 50px;
}

#how-it-works .feature-block h4 {
	margin-bottom: 10px;
}

.local-content h2 {
	
	margin-bottom: 20px;
}

.local-content p {}

.local-content ul {
	margin: 0px;
	list-style: none;
	padding: 0px;
}

.local-content li {}

.local-content li span {
	margin-right: 10px;
}

.block-bg {
	background: url(${endPoints.BLOCK_BG}) no-repeat left 60%;
}

.small-bg {
	background: url(${endPoints.SMALL_BG}) 0 50px no-repeat;
}

.small-bg2 {
	background: url(${endPoints.SMALL_BG_2}) no-repeat center;
	background-size: 100% 500px;
}


/* why people
--------------------------------*/

.why-people {
	background: #f4fafd;
}

.carousel-indicators {
	position: relative;
	bottom: 0;
	left: 0;
	bottom: 0 !important;
	z-index: 15;
	width: auto;
	padding-left: 0;
	margin: 30px auto 0 auto;
	margin-right: auto;
	text-align: center;
	list-style: none;
	margin-bottom: 0;
	display: inline-block;
}

.carousel-indicators li {
	margin: 0;
}




/*--------------------------------------------------------------
# services
--------------------------------------------------------------*/

.services {
	padding-top: 0px;
}

.services .no-p-l {
	padding-left: 0px !important;
}

.services .no-p-l img {
	width: 100%;
}

.services .no-p-r img {
	width: 100%;
}

.services .no-p-r {
	padding-left: 0px !important;
}

.services .left {
	margin-left: 35%;
}

.services .right {
	margin-right: 35%;
}

.services .content h1 {
	
}

.services .content a {
	color: ${(props) => props.theme.primaryColor};
	position: relative;
	padding-left: 40px;
	transition: 0.4s;
}

.services .content a:hover {
	text-decoration: none;
	margin-left: 10px;
	transition: 0.4s;
}

.services .code.icon {
	color: ${(props) => props.theme.blackColor};
	position: absolute;
	left: 0;
	top: -8px;
	background: ${(props) => props.theme.primaryColor};
	width: 30px;
	height: 30px;
	border-radius: 50%;
}

.services .icon:before {
	content: '';
	position: absolute;
	width: 8px;
	height: 8px;
	border-bottom: solid 1px currentColor;
	border-right: solid 1px currentColor;
	-webkit-transform: rotate(-45deg);
	transform: rotate(-45deg);
	top: 10px;
	left: 10px;
	color: ${(props) => props.theme.whiteColor};
}

.services .content p {
	color: #353535;
	line-height: 1.88;
	padding: 35px 0px 0 0;
	margin-bottom: 40px;
}


/*--------------------------------------------------------------
# get-in-touch
--------------------------------------------------------------*/

.get-in-touch .top {
	margin-bottom: 90px;
}

.get-in-touch .top .section-title h2 {
	
}

.get-in-touch .top .section-title {
	margin-bottom: 30px;
}

.get-in-touch .section-title h2 {
	color: ${(props) => props.theme.whiteColor};
}

.get-in-touch .section-title .brand-logos {
	max-width: 100%;
	height: 60px;
	margin-top: 30px;
	margin-bottom: 0px;
}

.get-in-touch .main-body {
	background: ${(props) => props.theme.hotRed};
	color: ${(props) => props.theme.whiteColor};
	position: relative;
	display: inline-block;
    width: 100%;
}

.get-in-touch .main-body:after {
	content: "";
	background: url(${endPoints.QUOTE_RIGHT}) no-repeat;
	width: 188px;
	height: 188px;
	position: absolute;
	background-size: 100%;
	right: 30px;
	bottom: -59px;
}

.get-in-touch .main-body:before {
	content: "";
	background: url(${endPoints.QUOTE_RIGHT}) no-repeat;
	width: 188px;
	height: 188px;
	position: absolute;
	background-size: 100%;
	top: -35px;
	left: 30px;
}

.get-in-touch .main-body h2 {
  margin-bottom: 20px;
  color:${theme.whiteColor} !important;
}
.get-in-touch .main-body h2 img{
	vertical-align:middle;
}

.get-in-touch .main-body p {
	color: ${(props) => props.theme.whiteColor};
}

.get-in-touch .main-body .c-image {
	margin-top: -140px;
}

.get-in-touch .bottom {
	background: url(${endPoints.RED_BOTTOM}) no-repeat;
	background-position: top center;
	background-size: 100%;
	padding: 55px 0px 150px;
	margin-top:-3px;
	@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
		background: ${(props) => props.theme.hotRed};
		padding: 55px 0px 0px;
    };
}

.get-in-touch .bottom .bottom_h1 {
	color: ${theme.whiteColor} !important;
	margin-bottom: 45px;
}

/* .get-in-touch .form-control {
	background: #bf1920 !important;
	border-radius: 30px !important;
	color: #fff !important;
	border: none !important;
	padding: 12px 20px !important;
	width: 100% !important;
} */

.get-in-touch .bottom button {
	background: #eef1f0;
	border-radius: 30px;
	color: #323232;
	border: none;
	padding: 10px 20px;
	cursor: pointer;
}
.enquiryform{
	text-align:left;
	h1{
		color: ${(props) => props.theme.LandingBlack};
	}
}

/* .get-in-touch .bottom button:focus {
	outline: none;
}

.get-in-touch .bottom input:focus {
	outline: none;
}

.get-in-touch .bottom input::-webkit-input-placeholder {
	color: #fff;
}

.get-in-touch .bottom input::-moz-placeholder {
	color: #fff;
}

.get-in-touch .bottom input:-ms-input-placeholder {
	color: #fff;
}

.get-in-touch .bottom input:-moz-placeholder {
	color: #fff;
} */


/*--------------------------------------------------------------
# old-school
--------------------------------------------------------------*/

.old-school ul {
	margin: 0px;
	padding: 0px;
	list-style: none;
}

.old-school .zig-zag {
	width: 85%;
}

.old-school .section-title h2 {
	
}

.old-school .zig-zag li {
	box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
	border-radius: 30px;
	padding: 16px 30px;
	background: ${(props) => props.theme.whiteColor};
}

.old-school .zig-zag li:nth-child(odd) {
	float: right;
	margin-bottom: 80px;
}

.old-school .zig-zag li:nth-child(even) {
	float: left;
	margin-top: 80px;
}

.old-school .steps li {
	display: block;
	margin-bottom: 90px;
	position: relative;
	z-index: 9;
}

.old-school .steps li h1 {
	
	padding-top: 16px;
}

.old-school .steps li p {}

.old-school .steps li:last-child {
	margin-bottom: 0px;
}

.old-school .steps li .icon {
	float: left;
	margin-right: 20px;
	box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
	padding: 20px;
	border-radius: 50%;
	width: 100px;
	height: 100px;
	line-height: 52px;
	text-align: center;
	background: ${(props) => props.theme.whiteColor};
}

.old-school .steps li:after {
	content: "";
	position: absolute;
	width: 5px;
	background: ${(props) => props.theme.lightWhite};
	height: 90px;
	left: 48px;
	z-index: 1;
}

.old-school .steps li.last:after {
	display: none;
}

.old-school .steps li img {}


/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/

.footer {
	padding-top: 50px;
}

.footer .footer-logo .navbar-brand {
	color: #595959;
	display: inline-block;
	float: none;
	height: 100%;
	padding-left: 0;
	padding-top: 0;
}

.footer .footer-logo p {
	color: #595959;
}

.footer .list-menu>h4 {
	color: #595959;
	padding-bottom: 20px;
}

.footer .list-menu ul li a {
	color: #595959;
  text-decoration: none;
  font-size: 16px;
}

.footer .list-menu ul li a img {
	width: 80%;
	margin-bottom: 20px;
}

.footer .copyrights {
	background: #6f6f6f;
	margin-top: 20px;
	text-align: center;
	padding: 10px 0px;
}

.footer .copyrights ul {
	margin: 0px;
	padding: 0px;
	text-align: right;
}

.footer .copyrights li {
	display: inline-block;
}

.footer .copyrights li a {
	color:${(props) => props.theme.whiteColor};
	margin-right: 25px;
}

.footer .copyrights p {
	margin: 0px;
	text-align: left;
	color:${(props) => props.theme.whiteColor};
}

.footer .copyrights .fa {}


/*--------------------------------------------------------------
# carousel
--------------------------------------------------------------*/

.carousel,
.carousel-inner {
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: -1;
}

.carousel-item {
	width: 100%;
	height: 50em;
	background-position: center center;
	background-size: cover;
	z-index: 0;
}

.carousel-fade .carousel-item {
	opacity: 0;
	transition-duration: 1.9s;
	transition-property: opacity;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
	opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
	opacity: 0;
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
	transform: translateX(0);
	transform: translate3d(0, 0, 0);
}

.col-half-offset {
	margin-left: 4.166666667%
}

.india-map {
	width: 540px;
	height: 602px;
	position: relative;
}

.india-map .map-img {
	width: 540px;
	height: 602px;
}

.map-pointer {
	position: absolute;
	cursor: pointer;
}

.map-pointer span {
	border-radius: 5px;
	padding: 1px 3px;
	background-color: #737373;
	color: ${(props) => props.theme.whiteColor};
	display: block;
}

.map-pointer span:hover {
	background-color: ${(props) => props.theme.hotRed};
}

.map-pointer .pointer {
	width: 10px;
}

.map-pointer.gurgaon {
	position: absolute;
	top: 130px;
	left: 135px;
}

.map-pointer.kolkata {
	position: absolute;
	top: 260px;
	right: 110px;
}

.map-pointer.mumbai {
	position: absolute;
	top: 330px;
	left: 85px;
}

.map-pointer.pune {
	position: absolute;
	top: 360px;
	left: 110px;
}

.map-pointer.hyderabad {
	position: absolute;
	bottom: 170px;
	left: 200px;
}

.map-pointer.bangalore {
	position: absolute;
	bottom: 105px;
	left: 170px;
}

.map-pointer.chennai {
	position: absolute;
	bottom: 89px;
	left: 203px;
}
.map-pointer.delhi {
	position: absolute;
	top: 135px;
	left: 165px;
}
.map-pointer.ahmedabad {
	position: absolute;
	top: 260px;
	left: 82px;
}


.location.none {
	display: none;
}
.office{
	font-size:12px;
	
	h1{
		font-family: 'Mulish',sans-serif !important;
		font-weight:800;
		font-size:26px;
		margin-bottom:15px;
	}
	strong{
		color: ${(props) => props.theme.LandingBlack};
	}
	b{
		color: ${(props) => props.theme.primaryColor}; 
	}
	p{
		font-family: 'Lato', sans-serif !important;
		font-size:16px;
		color: ${(props) => props.theme.LandingBlack};
		line-height: 22px;
	}
}
.location {
	box-shadow: 3px 3px 20px #24415D0F;
	text-align: left;
	width: 60%;
	padding: 20px;
	border-radius: 10px;
	position: absolute;
    bottom: 4%;
    right: 0;
	b{
		font-family: 'Mulish',sans-serif !important;
		color: ${(props) => props.theme.primaryColor};
		margin-bottom: 10px;
		font-size: 18px;
    display: block;
	}
	p{
		font-family: 'Lato', sans-serif !important;
		color: ${(props) => props.theme.LandingBlack};
		font-size: 16px;
    line-height: 22px;
		b{
			display: inline-block;
			margin-top: 5px;
		}
	}
}

.contact-us h1 {}


/* # News
--------------------------------------------------------------*/

.news ul {
	margin: 0px;
	padding: 0px;
	list-style: none;
	
}

.news li {
	border-bottom: #878c8e solid 1px;
	margin-bottom: 50px;
}

.news li a {
	
	text-decoration: none;
}

.news li a:hover {
	color: ${(props) => props.theme.LandingBlack};
	text-decoration: none;
}

.news li h1 {
	margin: 15px 0px;
	line-height:normal;
}

.news li p {
	margin-bottom: 50px;
}

.news li span {
	color: ${(props) => props.theme.primaryColor};
}

.merchant-section h2 {
	margin-bottom: 35px !important;
}


#benefit-section .rounded-img{
	background: #f7f7f7 !important;
	box-shadow: none !important;
}

/* # Common utilities
--------------------------------------------------------------*/

.res-img {
	width: 100%;
}

.gradient-bg-right-white{
	background: url(${endPoints.GRADIENT_ELEMENT}) no-repeat right #fff;
 }
.gradient-bg-left-white{
	background: url(${endPoints.GRADIENT_ELEMENT}) no-repeat left -20% #fff;
 }
.dot-bg-right{
  background: url(${endPoints.DOTS_BG}) no-repeat top right 30px;
}
.dot-bg-left{
  background: url(${endPoints.DOTS_BG}) no-repeat top left 30px;
}
.dot-bg-left-bottom-white{
	background: url(${endPoints.DOTS_BG}) no-repeat bottom left 30px #fff !important;
}
.dot-bg-right-white{
	background: url(${endPoints.DOTS_BG}) no-repeat top right 30px #fff !important;
}
  .dot-bg-right-gray{
	background: url(${endPoints.DOTS_BG}) no-repeat top right 30px #fbfbfb !important;
  }
.dot-bg-left-white{
	background: url(${endPoints.DOTS_BG}) no-repeat top left 30px #FFF !important;
}
.dot-bg-left-gray{
	background: url(${endPoints.DOTS_BG}) no-repeat top left 30px #fbfbfb !important;
}

gradient_element


.underline-center{ 
  position: relative;
}
.underline-center hr{
  position: absolute;
  width: 50px;
  height: 3px;
  background: ${(props) => props.theme.hotRed};
  left: 48%;
  border-top: 0px;
}
.underline-left{ 
  position: relative;
}
.underline-left hr{
  position: absolute;
  width: 50px;
  height: 3px;
  background: ${(props) => props.theme.hotRed};
  left: 0;
  border-top: 0px;
}
.icons {
	width: 75px;
	height: 75px;
}

.rounded-button {
	background: ${(props) => props.theme.primaryColor};
	border-radius: 25px;
	padding: 10px 20px;
	color:${(props) => props.theme.whiteColor};
	text-decoration: none;
	transition: 0.3s;
	margin-top: 26px;
	display: inline-block;
}

.rounded-button:hover {
	background: ${(props) => props.theme.whiteColor};
	border: ${(props) => props.theme.primaryColor} solid 1px;
	color: ${(props) => props.theme.primaryColor};
	text-decoration: none;
}



}
.points-bg {
	background-image: url(${endPoints.POINTS_BOTTOM}), url(${endPoints.POINTS_TOP});
	background-position: bottom, top;
	background-size: 100%, 100%;
	background-repeat: no-repeat, no-repeat;
	background-color: #fcdfe0;
	padding: 200px 0px;
}
.points-bg .people-list li {
	margin-bottom: 30px;
}
.rounded-img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	background: ${(props) => props.theme.lightWhite};
	position: relative;
	/* box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09); */
	line-height: 90px;
	display: inline-block;
	text-align: center;
}
.color-rounded-img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	background:${(props) => props.theme.lightWhite};
	position: relative;
	
	line-height: 90px;
	display: inline-block;
	text-align: center;
}

.hover-block .feature-block:hover{
  box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09);
  background: ${(props) => props.theme.whiteColor};
  transition: all .6s;
}
.hover-block .feature-block{
  transition: all .6s;
  padding: 50px 0px;
}
.hover-block .feature-block p{
  margin-bottom: 0px !important;
}

.thank-you h1{
	color: #ef5b5d !important;
	font-weight: bold;
}
.contact-details{
    padding: 0px;
    width: 50%;
    margin: 0 auto;
}
.contact-details li{
	list-style: none;
	float: left;
	width: 50%;
	background: #d6e5e9;
	border-top: #ef5b5d solid 5px;
	border-radius: 0px 0px 0px 5px;
	padding: 40px 0px;
	position: relative;
	font-size: 12px;
}
.contact-details li a{
	font-size: 18px;
	color:${(props) => props.theme.blackColor};
	font-weight: bold;
}
.contact-details li a:hover{
	font-size: 18px;
	color:${(props) => props.theme.blackColor};
	text-decoration: none;
}
.contact-details li:after{
	content: '';
	position: absolute;
	height: 100px;
	width: 1px;
	background: #ef5b5d;
	right: 0px;
	top: 20%;
}
.contact-details li:nth-child(2){
	border-radius: 0px 0px 5px 0px;
}
.contact-details li:nth-child(2):after{
	display: none;
}
.socia-media{
	margin: 40px 0px 0px 0px;
	padding: 0px;
	list-style: none;
	color: #4a4a4a;
}
.socia-media li{
	display: inline-block;
	margin-right: 10px;
	color: #4a4a4a;
}
.socia-media li a{
	color: #4a4a4a;
}
.zig-zag-list {
	margin: 0px;
	padding: 0px;
	list-style: none;
}
.zig-zag-list li {
	width: 80%;
	box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09);
	background-color: ${(props) => props.theme.whiteColor};
	padding: 15px 20px;
	border-radius: 20px;
	display: inline-block;
	margin-bottom: 20px;
	line-height: 50px;
}
.zig-zag-list li img {
	width: 50px;
	margin-right: 20px;
}
.zig-zag-list li:nth-child(odd) {
	margin-left: 60px;
}
.line-height-23 {
	line-height: 23px !important;
}
.banner-subscribe {
	background:${(props) => props.theme.whiteColor};
	border-radius: 30px;
	width: 40%;
	display: inline-block;
	padding: 10px;
	text-align: right;
}
.banner-subscribe .button {
	margin-top: 0px !important;
}
.banner-subscribe input[type="text"] {
	border: none;
	float: left;
}
.banner-subscribe input[type="text"]:focus {
	outline: none;
}
.corporate-zig-zag {
	margin: 0px;
	padding: 0px;
	list-style: none;
	float: left;
	margin-right: 5%;
}
.corporate-zig-zag li {
	background: ${(props) => props.theme.whiteColor};
	border-radius: 20px;
	padding: 10px;
	display: block;
	text-align: center;
	box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09);
	margin: 0px 0% 20% 0px;
	width: 134px;
	height: 156px;
}
.corporate-zig-zag li img {
	width: 60px;
}
.corporate-zig-zag li p {
	line-height: 18px;
	margin-top: 20px;
}

/*--------------------------------------------------------------
# gifting Section
--------------------------------------------------------------*/
.gifting h2 {
	margin: 15px 0px !important;
}
.gifting h1 {
	
	margin-bottom: 40px;
}
.gifting p {}

/*--------------------------------------------------------------
# Default Section
--------------------------------------------------------------*/
.default-section p {}
.default-section .feature-block p {
	margin-bottom: 50px;
}
.default-section .section-title {
	margin-bottom: 20px;
}
.default-section .rounded-img {
	margin-bottom: 20px;
}
.default-section h2 {
	
	margin-bottom: 40px;
}
.people-list {
	margin: 0px;
	padding: 0px;
	list-style: none;
	
}
.people-list li {
	margin-bottom: 10px;
}
.people-list li h2 {
	
}
.people-list li p {
	padding-left: 30px;
	padding-top: 10px;
	
}

/*--------------------------------------------------------------
# team profile
--------------------------------------------------------------*/
.team-profile {
	position: relative;
	margin-bottom: 80px;
}
.team-profile .profile-img {
	width: 20%;
	position: absolute;
	top: 58px;
	left: 80px;
	text-align: center;
}
.team-profile .profile-img a{
	display: block;
}
.team-profile .profile-img .fa {
	background: #0078B8;
	color:${(props) => props.theme.whiteColor};
	padding: 3px 4px 5px 5px;
	border-radius: 5px;
	margin-top: 13px;
}
.team-profile .profile-decription {
	width: 80%;
	/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ebffff+0,ffffff+100 */
	
	background: #ebffff;
	/* Old browsers */
	
	background: -moz-linear-gradient(left, #ebffff 0%, #ffffff 100%);
	/* FF3.6-15 */
	
	background: -webkit-linear-gradient(left, #ebffff 0%, #ffffff 100%);
	/* Chrome10-25,Safari5.1-6 */
	
	background: linear-gradient(to right, #ebffff 0%, #ffffff 100%);
	/* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ebffff', endColorstr='#ffffff', GradientType=1);
	/* IE6-9 */
	
	float: right;
	padding: 50px 100px;
	border-radius: 20px;
}
.team-profile .profile-decription h3 {
	margin-bottom: 35px;
}
.team-profile .profile-decription h2 span {}

/*--------------------------------------------------------------
# sub-menu
--------------------------------------------------------------*/
.sub-menu {
	border:${(props) => props.theme.lightGray} solid 1px;
	border-right: 0px;
	border-left: 0px;
}
.sub-menu ul {
	list-style: none;
	margin: 0px;
}
.sub-menu ul li {
	display: inline-block;
	width: 16%;
	text-align: center;
}
.sub-menu li a {
	display: block;
	color: ${(props) => props.theme.mediumGrey};
	padding: 20px 0px;
}
.sub-menu li a.active {
	text-decoration: none;
	color: ${(props) => props.theme.LandingBlack};
}

.sub-menu li a:hover {
	text-decoration: none;
	
}

/*--------------------------------------------------------------
# Dining Block
--------------------------------------------------------------*/
.dining-block {
	background: ${(props) => props.theme.whiteColor};
	border-radius: 30px;
	box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09);
	padding: 50px 60px;
	min-height: 550px;
	width: 90%;
	float: right;
}
.dining-block img {
	background: ${(props) => props.theme.lightWhite};
	padding: 20px;
	border-radius: 50%;
	width: 100px;
	height: 100px;
	/* box-shadow: 0px 13px 46px 0 rgba(0, 0, 0, 0.09); */
	margin: 30px 0px;
}
.dining-block h2 {
	margin: 0px 0px 30px 0px;
	
}
.dining-block p {}
.mobile-banner-content {
  line-height: 60px !important;
  font-size: 48px;
}

/*--------------------------------------------------------------
# Responsive iPad Landscape
--------------------------------------------------------------*/
@media (max-width: 1024px) {
	#mobile-nav-toggle {
		display: inline;
	}
	
	.col-half-offset {
		margin-left: 0px
	}
	
	#get-started .explore li {
		width: 100% !important;
	}
}

/*--------------------------------------------------------------
# Responsive Mobile & iPad portrait
--------------------------------------------------------------*/
@media (max-width: 767px) {
	.mobile-text-center {
		text-align: center !important;
	}
	
	
	
	.col-half-offset {
		margin-left: 0px
	}
	
	#get-started .explore li {
		width: 100% !important;
		margin-left: 0px;
	}
	
	#get-started .feature-block {
		margin-bottom: 20px;
		z-index: auto;
		height: auto;
	}
	
	#get-started .feature-block p {
		height: auto;
	}
	
	#get-started .feature-block:after {
		display: none;
	}
	
	.top-menu {
		display: none;
	}
	#header {
		z-index: 9;
		top: 30px;
	}
	.save-landing #header{
		top: 9px !important;
	}
	
	#get-started {
		background: ${(props) => props.theme.primaryColor};
		margin-top: 0px;
		padding-top: 40px;
	}
	.sub-menu {
		display: none;
	}
	.carousel-item {
		height: 20em;
	}
	.img-text h2{
		width: auto;
    left: 12%;
    top: -7%;
    font-size: 22px;
	}
	.banners{
		height: auto;
	}
	.banners .caption {
		top: 43%;
	}
	.banners.homeBanner .caption{
		margin-top: 0%;
		width: 55%;

	}
	.banners .caption h3 {
		line-height: 26px;
	}
	
	.india-map {
		width: 100%;
		overflow: auto;
		height: 602px;
		position: relative;
	}
	
	.india-map .map-img {
		width: 540px;
		height: 602px;
	}
	.our-values .col-5 {
		width: 100% !important;
		max-width: none !important; 
		flex: 0 0 100%;
	}
	.our-values{
		background: #f2f8ff;
	}
	.team-profile .profile-img{
		width: 100%;
		position: static;
		top: auto;
		left: auto;
		text-align: center;
	}
	.team-profile .profile-decription{
		width: 100%;
		padding: 20px;
		border-radius: 20px;
	}
	.corporate-zig-zag {
		float: none;
		margin: 4%;
	}
	.openings .card .joblocation{
		float: left;
	}
	.corporate-zig-zag li {
		display: inline-block;
		margin: 10px;
	}
	
	.zig-zag-list li {
		padding: 10px;
		width: 80%;
	}
	
	.zig-zag-list li img {
		margin-right: 0px;
	}
	
	.dining-block {
		width: 100%;
		margin: 20px 0 0 0;
		min-height: auto;
	}
	
	.img-text h1 {
		width: 65%;
		left: 15%;
		font-size: 24px;
		top: -2%;
	}
	
	.banners .caption a.button {
		padding: 5px 10px;
		margin-top: 15px;
	}
	
	#mobile-nav-toggle {
		margin: 16px 20px 0 0;
	}
	
	#get-started .section-title .brand-logos {
		height: auto;
	}
	
	.mobile-banner {
		margin-top: 72px;
	}
	
	.lg-none {
		display: block !important;
	}
	
	.sm-none {
		display: none !important;
	}
	
	.mobile-banner-content {
    line-height: 28px !important;
    font-size: 22px;
	}
	.services .no-p-r{
    padding-right: 0px;
  }
	.mobile-caption {
		top: 40% ;
		width: 56% ;
		left: 5% ;
	}
	
	/*--------------------------------------------------------------
# get-in-touch
--------------------------------------------------------------*/
	
	.get-in-touch .top {
		background: ${(props) => props.theme.transparentColor};
		padding: 50px 0px;
		margin-bottom: 0px;
	}
	
	.get-in-touch .section-title .brand-logos {
		height: auto;
	}
	
	.get-in-touch .top .section-title {
		margin-bottom: 0px;
	}
	
	.get-in-touch .main-body {
		padding-top: 50px;
	}
	
	.get-in-touch .main-body .c-image {
		margin-top: 0px;
	}
	
	.get-in-touch .bottom {
		/* background: #ff1b37;
		padding: 50px 0px; */
	}
	
	.get-in-touch .bottom input[type="text"],
	input[type="tel"],
	input[type="email"] {
		margin-bottom: 20px;
	}
	
	.get-in-touch .bottom button {
		margin-bottom: 20px;
	}
	
	.services .right {
		margin-right: 0px;
	}
	
	.services .left {
		margin-left: 0px;
	}
}
.blog-slider {
	/* width: 95%;
  position: relative;
  max-width: 800px;
  margin: auto;
  background: #fff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 25px;
  border-radius: 25px;
  height: 400px;
  transition: all .3s; */
	
	position: relative;
	margin: auto;
	transition: all .3s;
}
@media screen and (max-width: 992px) {
	.blog-slider {
		max-width: 680px;
		height: 400px;
	}
}
@media screen and (max-width: 768px) {
	.blog-slider {
		min-height: 500px;
		height: auto;
		margin: 180px auto;
	}
}
@media screen and (max-height: 500px) and (min-width: 992px) {
	.blog-slider {
		height: 350px;
	}
}
.blog-slider__item {
	display: flex;
	align-items: center;
}
@media screen and (max-width: 768px) {
	.blog-slider__item {
		flex-direction: column;
	}
}
.blog-slider__item.swiper-slide-active .blog-slider__img img {
	opacity: 1;
	transition-delay: .3s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>* {
	opacity: 1;
	transform: none;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(1) {
	transition-delay: 0.3s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(2) {
	transition-delay: 0.4s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(3) {
	transition-delay: 0.5s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(4) {
	transition-delay: 0.6s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(5) {
	transition-delay: 0.7s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(6) {
	transition-delay: 0.8s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(7) {
	transition-delay: 0.9s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(8) {
	transition-delay: 1s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(9) {
	transition-delay: 1.1s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(10) {
	transition-delay: 1.2s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(11) {
	transition-delay: 1.3s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(12) {
	transition-delay: 1.4s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(13) {
	transition-delay: 1.5s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(14) {
	transition-delay: 1.6s;
}
.blog-slider__item.swiper-slide-active .blog-slider__content>*:nth-child(15) {
	transition-delay: 1.7s;
}
.blog-slider__img {
	/*width: 300px;
  flex-shrink: 0;
  height: 300px;
   background-image: linear-gradient(147deg, #fe8a39 0%, #fd3838 74%);
  box-shadow: 4px 13px 30px 1px rgba(252, 56, 56, 0.2); 
  border-radius: 20px;
  transform: translateX(-80px);*/
	
	overflow: hidden;
}
.blog-slider__img:after {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	/*width: 100%;
  height: 100%;
   background-image: linear-gradient(147deg, #fe8a39 0%, #fd3838 74%); 
  border-radius: 20px;*/
	
	opacity: 0.8;
}
.blog-slider__img img {
	/* width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  border-radius: 20px; */
	
	transition: all .3s;
}
@media screen and (max-width: 768px) {
	.blog-slider__img {
		transform: translateY(-50%);
		width: 90%;
	}
}
@media screen and (max-width: 576px) {
	.blog-slider__img {
		width: 95%;
	}
}
@media screen and (max-height: 500px) and (min-width: 992px) {
	.blog-slider__img {
		height: 270px;
	}
}
.blog-slider__content {
	padding-right: 25px;
	height: 350px;
}
@media screen and (max-width: 768px) {
	.blog-slider__content {
		margin-top: -80px;
		text-align: center;
		padding: 0 30px;
	}
}
@media screen and (max-width: 576px) {
	.blog-slider__content {
		padding: 0;
	}
}
.blog-slider__content>* {
	opacity: 0;
	transform: translateY(25px);
	transition: all .4s;
}
.blog-slider__code {
	color: #7b7992;
	margin-bottom: 15px;
	display: block;
}
.blog-slider__title {
	color: #0d0925;
	margin-bottom: 20px;
}
.blog-slider__text {
	color: #4e4a67;
	margin-bottom: 30px;
	line-height: 1.5em;
}
.blog-slider__button {
	display: inline-flex;
	background-image: linear-gradient(147deg, #fe8a39 0%, #fd3838 74%);
	padding: 15px 35px;
	border-radius: 50px;
	color: ${(props) => props.theme.whiteColor};
	box-shadow: 0px 14px 80px rgba(252, 56, 56, 0.4);
	text-decoration: none;
	justify-content: center;
	text-align: center;
}
@media screen and (max-width: 576px) {
	.blog-slider__button {
		width: 100%;
	}
}
.blog-slider .swiper-container-horizontal>.swiper-pagination-bullets,
.blog-slider .swiper-pagination-custom,
.blog-slider .swiper-pagination-fraction {
	bottom: 10px;
	left: 0;
	width: 100%;
}
.blog-slider__pagination {
	position: absolute;
	z-index: 21;
	right: 20px;
	width: 11px !important;
	text-align: center;
	left: auto !important;
	top: 50%;
	bottom: auto !important;
	transform: translateY(-50%);
}
@media screen and (max-width: 768px) {
	.blog-slider__pagination {
		transform: translateX(-50%);
		left: 50% !important;
		top: 205px;
		width: 100% !important;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.blog-slider__pagination.swiper-pagination-bullets .swiper-pagination-bullet {
	margin: 8px 0;
}
@media screen and (max-width: 768px) {
	.blog-slider__pagination.swiper-pagination-bullets .swiper-pagination-bullet {
		margin: 0 5px;
	}
}
.blog-slider__pagination .swiper-pagination-bullet {
	width: 11px;
	height: 11px;
	display: block;
	border-radius: 10px;
	background: #062744;
	opacity: 0.2;
	transition: all .3s;
}
.blog-slider__pagination .swiper-pagination-bullet-active {
	opacity: 1;
	background: ${(props) => props.theme.primaryColor};
	height: 30px;
	box-shadow: 0px 0px 20px rgba(252, 56, 56, 0.3);
}
@media screen and (max-width: 768px) {
	.blog-slider__pagination .swiper-pagination-bullet-active {
		height: 11px;
		width: 30px;
	}
}

/*--------------------------------------------------------------
# Contact us form
--------------------------------------------------------------*/
.contact-form {
	border-bottom: #878c8e solid 1px;
	padding-bottom: 100px;
}
.contact-form label {
	width: 100%;
}
.contact-form .form-control {
	border-radius: 6px;
	background-color: #f4f4f4 !important;
	padding: 20px 0px 20px 24px;
	color: #1b1e2b;
	border: none;
	width: 100%;
	margin: 10px 0px 20px 0px;
}

/*--------------------------------------------------------------
# openings
--------------------------------------------------------------*/
.openings .card {
	border: 0px;
}
.openings .card .card-header {
	background: ${(props) => props.theme.whiteColor};
	border-bottom: 0px;
	padding: 25px 25px;
}
.openings .card .card-header .heading b{
	font-weight: 500;
}
.openings .card .card-body {
	height: 300px;
	overflow: auto;
}
.openings .card .card-body p {}
.openings .card .card-header a:hover {
	text-decoration: none;
}
.openings .card.even {
	background: #f4fafc;
}
.openings .card.even .card-header {
	background: #f4fafc;
	border-bottom: 0px;
}
.openings .card .heading {
	color: #626262;
}
.openings .card .joblocation {
	margin-right: 20px;
	margin-top: -4px;
}

/*--------------------------------------------------------------
# getInTouch
--------------------------------------------------------------*/
.getInTouch {
	border: 0px;
	/* margin-top: 20%; */
	border-radius: 10px !important;
}
.getInTouch .close {
	position: absolute;
	right: 10px;
	top: 10px;
	z-index: 9;
	width: 30px;
	height: 30px;
	border-right: 0px;
	border-top: 0px;
}
.getInTouch .modal-body {
	padding: 0px;
	background: ${(props) => props.theme.transparentColor};
	border-radius: 10px !important;
}
.getInTouch .address {
	padding: 205px 40px 40px 40px !important;
	background: url(${endPoints.CONACT_BG}) no-repeat top #fbfbfb;
	background-size: 100% 80%;
	border-radius: 10px 0px 0px 10px;
}
.getInTouch .address h2 {}
.getInTouch .address p {
	line-height: 2;
	margin-top: 10px;
	margin-bottom: 0px;
	line-height: 19px;
  color:${(props) => props.theme.LandingBlack};
  font-size: 11px;
}
.getInTouch .address p b {
	color: ${(props) => props.theme.blackColor};
}
.getInTouch .form {
	padding: 40px !important;
	background: ${(props) => props.theme.lightWhite};
	padding-right: 20px !important;
	border-radius: 0px 10px 10px 0px;
}
.getInTouch .form h1 {
	text-align: left;
	margin-bottom: 30px;
}
.getInTouch .half {
	width: 46%;
	float: left;
}
.getInTouch input[type=text],
input[type=tel],
input[type=email]
 {
	border-radius: 6px;
	background-color: ${(props) => props.theme.whiteColor};
	padding: 12px 0px 12px 24px;
	color: #1b1e2b;
	border: none;
	width: 100%;
}
.getInTouch .btn{
	background: ${(props) => props.theme.primaryColor};
    border-radius: 25px;
    border: ${(props) => props.theme.whiteColor} solid 1px;
    padding: 10px 40px;
    color:${(props) => props.theme.whiteColor};
    margin-top: 3px;
}
.getInTouch textarea{
	border-radius: 6px;
	background-color:${(props) => props.theme.whiteColor};
	padding: 12px 0px 12px 24px;
	color: #1b1e2b;
	border: none !important;
	width: 96%;
}
.getInTouch .form-control:focus {
	box-shadow: 0 0 0 0.1rem rgba(254, 25, 57, 0.19) !important;
}
.getInTouch select {
	border-radius: 6px !important;
	background-color: ${theme.whiteColor} !important;
	padding: 6px 0px 6px 24px !important;
	color: #818181 !important;
	border: none !important;
	width: 96%;
	height: 45px !important;
	text-indent: 19px;
}
.testi h4 {
	color: ${theme.whiteColor} !important;
}
.testi h4 span {
	display: block;
	line-height: 14px;
	margin-top: 14px;
}
.done {
	text-align: center;
	margin-top: 20%;
}
.done h4 {
	color: ${(props) => props.theme.secondaryColor};
}
.done svg {
	width: 10% !important;
}
.getshow {
	color: ${(props) => props.theme.whiteColor};
	text-align: center;
}
.lg-none {
	display: none;
}
.col-5 {
	width: 20% !important;
	max-width: 20%;
}
.values-grid .col-5 {
	width: 20% !important;
	max-width: 20%;
	float: left;
	padding:0px 5px;
	@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
		width: 100% !important;
    };
}


.text-animation{
	-webkit-transform: translateY(15px);
    -webkit-transition: opacity .25s ease-out,-webkit-transform .25s ease-out;
    opacity: 0;
    transform: translateY(15px);
    transition: opacity .25s ease-out,-webkit-transform .25s ease-out;
    transition: transform .25s ease-out,opacity .25s ease-out;
    transition: transform .25s ease-out,opacity .25s ease-out,-webkit-transform .25s ease-out;
}
.float{
	-webkit-transform: translate(0);
    opacity: 1;
    transform: translate(0);
}

.landing-exp{
	background-image:url(${endPoints.SAVE_LANDING_BG});
	position: relative;
    background-position: center center;
    background-size: cover;
    height: 50em;
}
.landing-exp.propel{
	background-image:url(${endPoints.PROPEL_LOGIN_BG}) !important;
}

.landing-exp .masthead {
	position: relative;
	overflow: hidden;
	padding-bottom: 3rem;
    z-index: 2;
    float: right;
}
.landing-exp h2{
    font-size: 16px;
    color: ${(props) => props.theme.LandingBlack};
	font-weight: normal;
	text-align: left;
}
.landing-exp h1{
    font-size: 28px;
    font-weight: normal;
	color: ${(props) => props.theme.LandingBlack};
	text-align: left;
}
.landing-exp h3{
    font-size: 16px;
    font-weight: normal;
	/* color: #ff1b36; */
	color: #737373;
	margin-top: 10px;
	text-align: left;
}
.landing-exp .masthead-content {
    /* padding-left: 3rem;
    padding-right: 10rem; */
    background: ${(props) => props.theme.whiteColor};
    padding: 30px;
    box-shadow: 0px 0px 23px 2px rgba(0, 0, 0, 0.15);
    min-height: 400px;
}
.landing-exp .masthead-content h2{
	font-size: 20px;
	margin-bottom: 15px;
}

.landing-exp .masthead-content h1 {
	font-size: 2.5rem
}

.landing-exp .masthead-content p {
	font-size: 1.2rem
}

.landing-exp .masthead-content p strong {
	font-weight: 700
}

.landing-exp .masthead-content .input-group-newsletter input {
	height: auto;
	font-size: 1rem;
	padding: 1rem
}

.landing-exp .masthead-content .input-group-newsletter button {
	font-size: .8rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 1px;
	padding: 1rem
}
.landing-exp .masthead-content .form-group {
	margin-bottom: 10px;
	text-align: left;
}
.landing-exp .masthead-content .form-control{
    padding: 7px 10px;
    height: auto;
    font-size: 12px;
    background:${(props) => props.theme.lightWhite};
    border: #ebebeb solid 1px;
}
.landing-exp .masthead-content .form-control:focus{
    box-shadow: none;
    border-color: ${(props) => props.theme.lightGray};
}
.landing-exp .masthead-content .form-group label{
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    margin-bottom: 4px;
	display:inline-block;
}
.landing-exp .masthead-content .form-group label b{
    color: ${(props) => props.theme.primaryColor};
    padding-left: 2px;
}
.landing-exp .masthead-content .req{
    font-size: 12px;
    color: #737373;
    font-weight: 400;
    margin-bottom: 4px;
    float: right;
}
.landing-exp .btn-secondary {
	background-color: ${(props) => props.theme.primaryColor};
	border-color: ${(props) => props.theme.hotRed};
	margin-top: 15px;
}

.landing-exp .btn-secondary:active,
.btn-secondary:focus,
.btn-secondary:hover {
	background-color: #d01614!important;
	border-color: #c01412!important
}

.landing-exp .input {
	font-weight: 300!important
}
/* #ff1936 */
.landing-exp .form-control::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #999999;
  }
.landing-exp .form-control::-moz-placeholder { /* Firefox 19+ */
    color: #999999;
  }
.landing-exp .form-control:-ms-input-placeholder { /* IE 10+ */
    color: #999999;
  }
.landing-exp .form-control:-moz-placeholder { /* Firefox 18- */
    color: #999999;
  }
  .landing-exp .form-footer-text{
    display: block;
    font-size: 12px;
	margin-top: 5px;
	color: #737373;
	text-align: center;
}
.landing-exp .logo{
	width: 20%;margin-bottom: 8%;
}
.landing-exp .mobile-bg{
	display: none;
}
.edge-mobile-bg {
	display: none;
  }
  .landing-exp .edge-logo{
	width: 30%;margin-bottom: 4%;
}


@media only screen and (max-width: 600px) {
	.edge-mobile-bg {
	  width: 100%;
	  display: inherit;
	}
	.edge-desktop-bg{
		display: none;
	  }
	  .landing-exp{
		position: static;
		height: auto;
		background-image: none;
	}
	.landing-exp .edge-logo{
		width: 50%;margin-bottom: 8%;
	}
	.container2 .slides{
		text-overflow: ellipsis;
		white-space: nowrap; 
  		overflow: hidden;
	}
	.landing-exp.propel{
		background-image:none !important;
	}
  }

@media (pointer:coarse) and (hover:none) {
	.landing-exp{
		position: static;
		height: auto;
		background-image: none;
	}
	.landing-exp .col-md-12{
		/* text-align: center; */
		/* background: url(../../corporate-landing/img/mobile-bg.png) no-repeat bottom;
		padding-bottom: 30%; */
	}
	.landing-exp .logo{
		width: 50%;margin-bottom: 8%;
	}
	.landing-exp .mobile-bg{
		display: inherit;
		width: 100%;
	}
	.landing-exp .desktop-bg{
		display: none;
	}
	.landing-exp .img-bg{
		display: none;
	}
}
.news-scroll{
	position: fixed;
    width: 100%;
    background: ${(props) => props.theme.primaryColor};
    z-index: 99;
    color: ${(props) => props.theme.whiteColor};
    height: 30px;
    text-align: center;
    font-size: 14px;
	line-height: 30px;
	top: 0px;
}

.container2{
	height: 30px;
	overflow: hidden;
}
.container2 .slides{
	height: 30px;
	overflow: hidden;
}
/* #onpage{
	position: relative;
} */

#onpage button{
	position: absolute;
	z-index: 9;
	right: 20px;
	background: ${(props) => props.theme.lightGray};
	opacity: 1;
	color: ${(props) => props.theme.whiteColor};
	width: 30px;
	height: 30px;
	border-radius: 50%;
	/* line-height: 22px; */
	font-size: 18px;
	top: 20px;
}
#onpage img{
	/* background: url(images/bg.jpg) no-repeat center center fixed;  */
  /* -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
	background-size: cover; */
	width: 100%;
}
#onpage .modal-dialog{
	max-width: 100%;
	margin: 0px;
	padding: 0px;
	border-radius: 0px;
	height: 100vh;
	overflow: hidden;
}
#onpage .modal-body{
	padding: 0px;
	margin: 0px;
	overflow: hidden;
}
#onpage .modal-content{
	border: none;
	border-radius: 0px;
}
.whatsapp{
	position: fixed;
	bottom: 70px;
	right: 15px;
	width: 40px;
	height: 40px;
	background: #25d366;
	text-align: center;
	border-radius: 50%;
	line-height: 37px;
	color:${(props) => props.theme.whiteColor};
	font-size: 24px;
	box-shadow: 0px 0px 5px 0px rgba(169, 169, 169, 0.75);
	border: #25d366 solid 1px;
	transition: .5s ease-in-out;
}
.whatsapp:hover{
	background:${(props) => props.theme.whiteColor};
	border: #25d366 solid 1px;
	color: #25d366;
	box-shadow: 0px 0px 5px 0px rgba(169, 169, 169, 0.75);
}
.container-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
section{
	display:inline-block;
	width:100%;
}

.btn-success{
	color: ${(props) => props.theme.whiteColor};
    background-color: #28a745;
    border-color: #28a745;
}


.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: ${(props) => props.theme.whiteColor};
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}


.save-landing-page .banner-side-image img {
 display: none;
 }
  .save-landing-page a, .next-step-saggle a {
     border: 1px solid ${(props) => props.theme.transparentColor};
    white-space: nowrap;
    padding: 5px 15px !important;
    font-size: 14px;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    background-color: rgb(52, 170, 68);
    border-color: rgb(36, 149, 51);
    color: ${theme.whiteColor} !important;
    margin-top: 45px;
	}

.save-business-section .col-md-12 {
    text-align: left;
    padding-left: 0;
}
.save-business-section .col-md-5 {
    text-align: left;

}
.get-in-touch .bottom {
    /* padding: 30px 0px 12px;
        background: #ED3B41; */
}
 .new-side-padd {
 padding: 50px;
 }
 .save-landing-page {
    display: inline-block;
    height: 100%;
    width: 100%;
	background: url(${endPoints.SAVE_LANDINNGPAGE_BG});
	background-repeat: no-repeat;
    background-position: right;
    position: relative;
}
 .save-landing-page h1 {
     padding-bottom: 50px;
 }
 .video-section-popup {
margin: 50px 0px;
 }
 .new-padd-section {
padding-bottom: 40px;
    padding-top: 56px;
 }
.save-landing-page { 
    padding: 170px 0px;
 } 
.save-landing-page a {

 }
.reduce-employee-section .button {
    background: #eef1f0;
    border-radius: 30px;
    color: #323232;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    text-decoration: none;
}
.reduce-employee-section {
 
 }
.reduce-employee-section h3 {
 color: ${theme.whiteColor} !important;
 padding-top: 8px;
 }
 .slider-wrapper {
font-size: 40px;
    color: #aaa;
    font-weight: bold;
    text-transform: uppercase;
    display: block;
    text-align: left;
    justify-content: left;
}
.slider-wrapper .slider{
  height: 50px;
  overflow: hidden;
}
.slider-wrapper .slider div {
color: ${(props) => props.theme.whiteColor};
    height: 40px;
    margin-bottom: 60px;
    padding: 5px 10px;
    box-sizing: border-box;
    font-size: 18px;
    text-transform: initial;
    border-radius: 10px;
    width: 90%;
}
.slider-wrapper .slider-text1 {
  background: #616161;
  animation: slide 10s linear infinite;
}
.slider-wrapper .slider-text2 {
  background: #616161;
}
.slider-wrapper .slider-text3 {
  background: #616161;
}
@keyframes slide {
  0% {margin-top:-300px;}
  5% {margin-top:-200px;}
  33% {margin-top:-200px;}
  38% {margin-top:-100px;}
  66% {margin-top:-100px;}
  71% {margin-top:0px;}
  100% {margin-top:0px;}
}
.save-page-countdown {
    display: inline-block;
    height: 100%;
    width: 100%;
	background: url(${endPoints.SAVE_BACKGROUND_LINE});
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
}
.save-page-countdown {
  .col-md-10 {
    background: ${(props) => props.theme.lightWhite};
    padding: 5px 0px 22px;
    border: solid 2px #CED7E0;
}
}
.save-page-countdown h2 {
color: ${theme.primaryColor} !important;
    font-size: 40px;
}
.save-page-countdown .feature-block {
    padding: 20px 10px 10px 10px;
    transition: all 0.5s ease-in-out 0s;
    position: relative;
}
.save-page-countdown .feature-block h4 {
    margin-bottom: 15px;
    line-height: 22px;
}
.save-page-countdown .explore li {
    width: 30%;
    margin-right: 2%;
    float: left;
	    list-style: none;
}
.save-business-section input[type=email] {
    border-radius: 6px;
    background-color: ${(props) => props.theme.whiteColor};
    padding: 12px 0px 12px 24px;
    color: #1b1e2b;
    border: solid ${(props) => props.theme.lightGray};
    width: 100%;
}
.save-business-section .btn-success {
    color: ${(props) => props.theme.whiteColor};
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 10px !important;
    padding: 10px 43px !important;
    margin-top: 10px;
    left: 0px;
    position: absolute;
}
.save-business-section li {
list-style: none;
    padding: 6px 0px 6px 0px;
}
.save-business-section ul {
    padding: 0px 0px 0px 10px;
}
.save-business-section li img {
width: 19%;
    padding-right: 12px;
	vertical-align: middle;
}
.save-business-section li p {
	margin-bottom:0px;
}
.manage-expenses img {
width: 120%;
}
.manage-expenses h5 {
    padding-top: 13px;
}
.manage-expenses .manage-expenses-border {
    border: solid 2px #CED7E0;
	    padding: 12px 10px;
}
.video-background {
background: url(img/video-img.jpg);
    padding: 135px 0px;
    background-size: cover;
    background-repeat: no-repeat;
}
.video-background .res-img {
    width: 18%;
    margin: 0 auto;
    display: block;
}
.video-background .res-img:hover {
    width: 18%;
    margin: 0 auto;
    display: block;
	opacity: 0.86;
	transition: transform .15s ease;
	transform: scale(1.1);
}
.nav-fill .nav-item {
background: ${(props) => props.theme.lightWhite};
    font-size: 20px;
    color: #495057;
    border-bottom: solid 3px #D2282F !important;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color:${(props) => props.theme.whiteColor};
    background-color: ${(props) => props.theme.hotRed};
    border: solid 1px ${(props) => props.theme.hotRed};
    border-bottom: solid 4px ${(props) => props.theme.hotRed};
    font-size: 20px;
}
.px-sm-0 {
    padding-left: 0!important;
    border: solid 2px #f8eded;
    border-radius: 0px 0px 20px 20px;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .save-landing-page .banner-side-image img {
 display: block;
  padding: 50px 0px;
 }
 .save-landing-page {
    display: inline-block;
    height: 100%;
    width: 100%;
    background: #e2e6ef;
	background-repeat: no-repeat;
    background-position: right;
    position: relative;
}
 .slider div {
color: ${(props) => props.theme.whiteColor};
    height: 61px;
    margin-bottom: 40px;
    padding: 1px 17px;
    text-align: center;
    box-sizing: border-box;
    font-size: 19px;
    text-transform: initial;
    border-radius: 10px;
}
.slider {
    height: 70px;
}
.save-page-countdown .explore li {
    width: 100%;
    margin-right: 0;
    float: none;
    list-style: none;
    margin: 0 auto;
    display: block;
    text-align: center;
}
.manage-expenses img {
    width: 20%;
}
#reduce-employee-section h3 {
    color: ${theme.whiteColor} !important;
    padding-top: 8px;
    padding-bottom: 48px;
}
.manage-expenses .manage-expenses-border {
    margin-bottom: 30px;
}
.save-business-section .col-md-12 {
    margin: 0 auto;
    display: block;
    text-align: center;
}
.save-page-countdown ul {
    padding: 0;
}
.save-landing-page { 
    padding: 60px 0px;
 } 
}
@media only screen and (min-device-width: 480px) and (max-device-width: 736px) {
  .save-landing-page .banner-side-image img {
 display: block;
 padding: 50px 0px;
 }
.save-landing-page {
    display: inline-block;
    height: 100%;
    width: 100%;
    background: #e2e6ef;
	background-repeat: no-repeat;
    background-position: right;
    position: relative;
}
.manage-expenses img {
    width: 25%;
}
.manage-expenses .manage-expenses-border {
    margin-bottom: 30px;
}
.save-business-section .col-md-12 {
    margin: 0 auto;
    display: block;
    text-align: center;
}
.save-page-countdown ul {
    padding: 0;
}
.save-landing-page { 
    padding: 60px 0px;
 }
}




/*
 CSS for the main interaction
*/
.tabset > input[type="radio"] {
  position: absolute;
  left: -200vw;
}

.tabset .tab-panel {
  display: none;
}

.tabset > input:first-child:checked ~ .tab-panels > .tab-panel:first-child,
.tabset > input:nth-child(3):checked ~ .tab-panels > .tab-panel:nth-child(2),
.tabset > input:nth-child(5):checked ~ .tab-panels > .tab-panel:nth-child(3),
.tabset > input:nth-child(7):checked ~ .tab-panels > .tab-panel:nth-child(4),
.tabset > input:nth-child(9):checked ~ .tab-panels > .tab-panel:nth-child(5),
.tabset > input:nth-child(11):checked ~ .tab-panels > .tab-panel:nth-child(6) {
  display: block;
}

.tabset > label {
  position: relative;
  display: inline-block;
  background: ${(props) => props.theme.lightWhite};
    font-size: 20px;
    color: #495057;
    border-bottom: solid 3px #D2282F !important;
  padding: 15px;
  border-bottom: 0;
  cursor: pointer;
  width: 50%;
text-align: center;
}


.tabset > label:hover,
.tabset > input:focus + label {
	color: #495057;
}

.tabset > label:hover::after,
.tabset > input:focus + label::after,
.tabset > input:checked + label::after {
  background: #06c;
}

.tabset > input:checked + label {
  /* border-color: #ccc;
  border-bottom: 1px solid #fff;
  margin-bottom: -1px; */

  color: ${(props) => props.theme.whiteColor};
    background-color: ${(props) => props.theme.hotRed};
    border: solid 1px ${(props) => props.theme.hotRed};
    border-bottom: solid 4px ${(props) => props.theme.hotRed};
    font-size: 20px;
}

.tab-panel {
  padding: 30px 0;
  border-top: 1px solid${(props) => props.theme.lightGray};
}
`;

export default StyledLanding;



// WEBPACK FOOTER //
// client/components/StyledLanding/index.js